import { Breadcrumbs } from '@components/Breadcrumbs'
import { useIsMobile } from '@hooks/use-media-query'
import { NormalizedWrapper } from '@theme'

import { config } from './config'
import {
  BackgroundWrapper,
  Title,
  Description,
  Wrapper,
  Tag,
  TagsWrapper,
  StyledArrows,
  BackgroundDecorativeWrapper,
} from './styles'

const { title, description, tags } = config

export function Header() {
  const isMobile = useIsMobile()

  return (
    <BackgroundWrapper>
      <BackgroundDecorativeWrapper>
        <NormalizedWrapper>
          {!isMobile && <Breadcrumbs />}
          <Wrapper>
            <Title>{title}</Title>
            <Description>{description}</Description>
            <TagsWrapper>
              {tags.map(tag => (
                <Tag key={tag}>{tag}</Tag>
              ))}
            </TagsWrapper>
            <StyledArrows />
          </Wrapper>
        </NormalizedWrapper>
      </BackgroundDecorativeWrapper>
    </BackgroundWrapper>
  )
}
